<template>
  <custom-dialog :visible="visible" width="680px" class="feed_back_addTag_dialog" :title="model.title" v-on="$listeners" appendToBody>
    <div class="dialog-body">
      <div class="input-container">
        <el-form ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col>
              <el-form-item :label="$t('components_feed_back_addTag_dialog.ci_tiao_nei_rong')" prop="tagName">
                <el-input v-model="form.tagName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>

  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        tagName: '', // 内容
        tagType: '', // 标签类型
        // asm_feedback_tag_type
        // 2
        // 改善措施
        // 3
        // 处理结果（客服）
        // 4
        // 处理结果（品质）
      },
    };
  },
  mounted: function () {
    this.initForm();
  },

  computed: {
    rules() {
      return {
        tagName: [
          {
            required: true,
            message: this.$t('Common.com_required')
          }
        ]
      };
    },
  },
  methods: {
    initForm() {

    },

    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.form.tagType = this.model.tagType;
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.feedbackTagAdd, this.form, true).then(() => {
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_add_success')
            });
            this.$emit('success');
          });
        }
      });

    },

  }
};
</script>

<style lang="scss">
.feed_back_addTag_dialog{

}
</style>
